// ABOUTME: Medidas por fotograma para el escaneo: ángulos de la pose y extremos de la
// ABOUTME: silueta de cabeza+pelo en cm relativos al origen de la cabeza.
import { Euler, Matrix4 } from "three";
import { cmPerPixel, projectHeadToScreen, type Size } from "./fit";
import type { Extents } from "./scan";
import type { CategoryMask } from "./segmenter";
import { measureSilhouette } from "./silhouette";

/** Punto local a la altura de las cejas: hasta esa fila se busca la anchura de la cabeza. */
const EYEBROW_LOCAL: [number, number, number] = [0, 3.5, 5];

export function poseAngles(pose: number[]): { yawDeg: number; pitchDeg: number } {
  const e = new Euler().setFromRotationMatrix(new Matrix4().fromArray(pose), "YXZ");
  return { yawDeg: (e.y * 180) / Math.PI, pitchDeg: (e.x * 180) / Math.PI };
}

export function extentsFromMask(mask: CategoryMask, fovDeg: number, pose: number[]): Extents | null {
  const size: Size = { width: mask.width, height: mask.height };
  const eyebrow = projectHeadToScreen(EYEBROW_LOCAL, size, fovDeg, pose);
  const px = measureSilhouette(mask.data, mask.width, mask.height, {
    referenceRow: eyebrow.y,
    minRun: Math.max(3, Math.round(mask.width * 0.03)),
  });
  if (!px) return null;
  const origin = projectHeadToScreen([0, 0, 0], size, fovDeg, pose);
  const cm = cmPerPixel(-pose[14], fovDeg, mask.height);
  return {
    top: (origin.y - px.topRow) * cm,
    left: (px.leftCol - origin.x) * cm,
    right: (px.rightCol + 1 - origin.x) * cm,
  };
}
